import { Routes } from '@angular/router';
import { Login } from './features/login/login';
import { Logout } from './features/logout/logout';
import { LogoutError } from './features/logout/logout-error';

/**
 * Il `title` per rotta lo applica il router: senza, la scheda del browser resterebbe
 * "Accedi" anche sulle pagine di uscita, perché l'index.html ha un titolo statico.
 */
export const routes: Routes = [
  // Non lazy: sono tre schermate minuscole, un chunk in più sarebbe solo latenza.
  { path: 'login', component: Login, title: 'Accedi' },
  // security.sso.logout-error-url. Prima della rotta 'logout' perché più specifica.
  { path: 'logout/error', component: LogoutError, title: 'Uscita non completata' },
  // Conferma di RP-Initiated Logout: security.sso.logout-url lato sso-bck.
  { path: 'logout', component: Logout, title: 'Esci' },
  // Qualsiasi altro percorso (compresa la root) porta al login; i query param sono preservati.
  { path: '**', redirectTo: 'login' },
];
